import React from "react";
import { formatPhone } from "../utility/formatPhone";
import { Card, CardBody, CardTitle, CardSubtitle, ListGroup, ListGroupItem } from "reactstrap";

const ProfileDetail = ({ userDetail }) => {
    return (
        <Card
            color="light"
            body
            className="text-center">
            <CardBody>
                <CardTitle>{userDetail.username} </CardTitle>
                {/* <CardSubtitle></CardSubtitle> */}
                <ListGroup>
                    <ListGroupItem>Total Parked: {userDetail.totalParked}</ListGroupItem>
                    <ListGroupItem>Total Retrieved: {userDetail.totalRetrieved ?? 0}</ListGroupItem>
                    <ListGroupItem>
                        Name: {userDetail.firstName} {userDetail.lastName}
                    </ListGroupItem>
                    <ListGroupItem>Phone: {formatPhone(userDetail.phone)}</ListGroupItem>
                    <ListGroupItem>Email: {userDetail.email}</ListGroupItem>
                </ListGroup>
            </CardBody>
        </Card>
    );
};
export default ProfileDetail;
